import React, {useContext, useEffect, useRef, useState} from "react";
import {useIdleTimer} from 'react-idle-timer';
import {TEXT_SECONDS_SINGLE, TEXT_SECONDS_PLURAL} from "../../contants/common";
import AppContext, {
	CONNECTION_STATUS_DEFAULT,
	CONNECTION_STATUS_RECONNECTION,
} from "../../store";
import Popup from '../Popup/Popup';

/* Production */
const TIME_IDLE_MINUTES = (60 / 60); /* 1min | 60*/
const TIME_PROMPT_MINUTES = (15 / 60); /* 0.25min | 15sec */

/* Development */
// const TIME_IDLE_MINUTES = (6 / 60); /* 0.1min | 6sec */
// const TIME_PROMPT_MINUTES = (10 / 60); /* 0.1666min | 10sec */

const TIME_IDLE_SECONDS = Math.round((TIME_IDLE_MINUTES * 60));
const TIME_PROMPT_SECONDS = Math.round((TIME_PROMPT_MINUTES * 60));

export const TIME_DISCONNECT_SECONDS = 15;
export const TIME_WARNING = TIME_IDLE_SECONDS * 1000;
export const TIME_ERROR = TIME_IDLE_SECONDS * 1000;
export const TIME_ACTION = TIME_PROMPT_SECONDS * 1000;

/* Total logout time: TIME_IDLE_SECONDS + (2 * TIME_DISCONNECT_SECONDS) */
export default function PopupIdle() {
	const {
		toggleStream,
		connectionStatus,
		setConnectionStatus,
	} = useContext(AppContext)
	const [visible, setVisible] = useState(false);
	const [remaining, setRemaining] = useState(TIME_PROMPT_SECONDS);
	const remainingTimerRef = useRef(null);

	const setTimer = () => {
		remainingTimerRef.current = setInterval(() => {
			setRemaining(v => v - 1);
		}, 1000);
	};
	const clearTimer = () => clearInterval(remainingTimerRef.current);

	const {
		reset,
	} = useIdleTimer({
		timeout: TIME_WARNING,
		promptTimeout: TIME_ACTION,
		onPrompt: () => {
			setTimer();
			setVisible(true);
		},
		onIdle: () =>  {
			setConnectionStatus(CONNECTION_STATUS_RECONNECTION);
			toggleStream(false);
		},
		onAction: () => {
			reset();
			clearTimer();
			visible && setVisible(false);
			setRemaining(TIME_PROMPT_SECONDS);
			if(connectionStatus === CONNECTION_STATUS_DEFAULT) {
				toggleStream(true);
			}
		},
	});

	useEffect(() => {
		return clearTimer;
	}, [])

	const textSeconds = remaining > 1 ? TEXT_SECONDS_PLURAL : TEXT_SECONDS_SINGLE;

	return (
		<Popup
			name={'Idle'}
			title={'INAKTIVITÄT'}
			visible={visible}
		>
			<>
				<span>Du bist seit {TIME_IDLE_MINUTES} Minuten inaktiv.</span>
				<span>In {Math.round(remaining)} {textSeconds} wirst du automatisch ausgeloggt.</span>
			</>
		</Popup>
	)
}
